import React from "react";
import styled from "styled-components";
import { device } from "./device";

import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import LanguageIcon from "../assets/ar_icon_button/language.svg";
import ChineseIcon from "../assets/ar_icon_button/Chinese.svg";
import EngIcon from "../assets/ar_icon_button/Eng.svg";

const StyledLanguageIconButton = styled(IconButton)`
  position: absolute;
  top: 0px;
  right: 0px;
  padding: 3%;
`;

const StyledChineseIcon = styled.img`
  width: 65%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
`;

const StyledEngIcon = styled.img`
  width: 80%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
`;

const StyledMenu = styled(Menu)`
  & > .MuiPaper-root {
    width: 15%;

    @media ${device.mobileXS} {
      width: 17%;
    }
    @media ${device.mobileS} {
      width: 15%;
    }
    @media ${device.iPhone5} {
      width: 18%;
    }
    @media ${device.mobileM} {
      width: 15%;
    }
    @media ${device.mobileL} {
      width: 10%;
    }
  }
`;

const options = [
  <StyledChineseIcon src={ChineseIcon} alt="Chinese Language" />,
  <StyledEngIcon src={EngIcon} alt="English Language" />,
];
const LanguageButton = ({
  handleMenuClick,
  anchorEl,
  handleClose,
  handleLang,
  selectedIndex,
}) => {
  return (
    <>
      <StyledLanguageIconButton
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleMenuClick}
      >
        <img src={LanguageIcon} alt="Language Button" />
      </StyledLanguageIconButton>
      <StyledMenu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        MenuListProps={{ disablePadding: true }}
      >
        {options.map((option, index) => (
          <MenuItem
            key={index}
            selected={index === selectedIndex}
            onClick={(e) => handleLang(e, index)}
            data-lang={index}
          >
            {option}
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  );
};

export default LanguageButton;
